import type { Edition } from '../edition/types.js';
import type { MarketplacePackInfo } from '../services/api.js';
import type { CardPackInfo } from './card-packs.js';

/**
 * A pack from the marketplace as the app's own `CardPackInfo`. A `mature` pack is adult-edition only here too (the
 * marketplace refuses it to the kids edition as well; this keeps a stored copy from ever being offered to a child's build).
 * Images are served from the marketplace, with the edition on the query so it can apply the same rule.
 */
export function communityPack(info: MarketplacePackInfo, marketplaceUrl: string, edition: Edition): CardPackInfo {
  return {
    id: info.id,
    name: info.name,
    tagline: info.tagline,
    family: 'community',
    editions: info.contentRating === 'everyone' ? ['kids', 'adult'] : ['adult'],
    files: Object.keys(info.files),
    base: `${marketplaceUrl}/api/packs/${encodeURIComponent(info.id)}/files`,
    query: `?edition=${edition}`,
    author: info.author,
  };
}

/** The token in whatever a person pastes: a full share link (`https://.../share/<token>`), `/share/<token>`, or the bare token. */
export function parseShareToken(input: string): string | null {
  const text = input.trim();
  if (!text) return null;
  const fromPath = /\/share\/([A-Za-z0-9_-]{8,64})\/?(?:[?#].*)?$/.exec(text)?.[1];
  const token = fromPath ?? (/^[A-Za-z0-9_-]{8,64}$/.test(text) ? text : null);
  return token ?? null;
}
